<template>
  <nav>
    <div id="nav" v-if="navTypeIndex === 1">
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon1.png" alt="">
          <span>交易管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 1 ? 'item item-select' : 'item'" @click="selectItem(1)">我的订单</div>
          <div :class="selectNav == 2 ? 'item item-select' : 'item'" @click="selectItem(2)">我的求购订单</div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/maijiaicon/2.png" alt="">
          <span>售后管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 3 ? 'item item-select' : 'item'" @click="selectItem(3)">售后申请</div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/maijiaicon/3.png" alt="">
          <span>合同管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 4 ? 'item item-select' : 'item'" @click="selectItem(4)">我的合同</div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/maijiaicon/4.png" alt="">
          <span>发票管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 5 ? 'item item-select' : 'item'" @click="selectItem(5)">申请开票</div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/maijiaicon/5.png" alt="">
          <span>收藏管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 6 ? 'item item-select' : 'item'" @click="selectItem(6)">我的收藏</div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/maijiaicon/6.png" alt="">
          <span>资产管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 7 ? 'item item-select' : 'item'" @click="selectItem(7)">我的资产</div>
        </div>
      </div>
      <!--       <div class="item-box">-->
      <!--        <div class="title">-->
      <!--          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon2.png" alt="">-->
      <!--          <span>供求管理</span>-->
      <!--        </div>-->
      <!--        <div class="content">-->
      <!--          <div-->
      <!--            :class="selectNav==2?'item item-select':'item'"-->
      <!--            @click="selectItem(2)"-->
      <!--            >供应信息</div>-->
      <!--          <div-->
      <!--            :class="selectNav==3?'item item-select':'item'"-->
      <!--            @click="selectItem(3)"-->
      <!--            >求购信息</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="item-box">-->
      <!--        <div class="title">-->
      <!--          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon3.png" alt="">-->
      <!--          <span>经纪人管理</span>-->
      <!--        </div>-->
      <!--        <div class="content">-->
      <!--          <div-->
      <!--            :class="selectNav==4?'item item-select':'item'"-->
      <!--            @click="selectItem(4)"-->
      <!--            >经纪人信息</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/maijiaicon/7.png" alt="">
          <span>账户管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 8 ? 'item item-select' : 'item'" @click="selectItem(8)">基本信息</div>
          <div :class="selectNav == 9 ? 'item item-select' : 'item'" @click="selectItem(9)">账号安全</div>
          <div :class="selectNav == 10 ? 'item item-select' : 'item'" @click="selectItem(10)">收货地址管理</div>
          <div :class="selectNav == 11 ? 'item item-select' : 'item'" @click="selectItem(11)">我的消息</div>
          <div :class="selectNav == 12 ? 'item item-select' : 'item'" @click="selectItem(12)">我的留言</div>
<!--          <div :class="selectNav == 13 ? 'item item-select' : 'item'" @click="selectItem(13)">实名认证</div>-->
          <div :class="selectNav == 14 ? 'item item-select' : 'item'" @click="selectItem(14)">公司认证</div>
        </div>
      </div>
    </div>
    <div id="nav" v-else>
      <!--      <div class="item-box">-->
      <!--        <div class="title">-->
      <!--          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon1.png" alt="">-->
      <!--          <span>交易管理</span>-->
      <!--        </div>-->
      <!--        <div class="content">-->
      <!--          <div :class="selectNav == 1 ? 'item item-select' : 'item'" @click="selectItem(1)">我的销售订单</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon2.png" alt="">
          <span>店铺管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 1 ? 'item item-select' : 'item'" @click="selectItem(1)">商品管理</div>
          <div :class="selectNav == 2 ? 'item item-select' : 'item'" @click="selectItem(2)">订单管理</div>
          <div :class="selectNav == 3 ? 'item item-select' : 'item'" @click="selectItem(3)">店铺信息管理</div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon5.png" alt="">
          <span>售后管理</span>
        </div>
        <div class="content">
          <div
            :class="selectNav==4?'item item-select':'item'"
            @click="selectItem(4)"
          >售后列表
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon6.png" alt="">
          <span>发票管理</span>
        </div>
        <div class="content">
          <div
            :class="selectNav==5?'item item-select':'item'"
            @click="selectItem(5)"
          >开票审核
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon7.png" alt="">
          <span>合同管理</span>
        </div>
        <div class="content">
          <div
            :class="selectNav==6?'item item-select':'item'"
            @click="selectItem(6)"
          >我的销售合同
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon8.png" alt="">
          <span>交易评价</span>
        </div>
        <div class="content">
          <div
            :class="selectNav==7?'item item-select':'item'"
            @click="selectItem(7)"
          >评价列表
          </div>
        </div>
      </div>
      <!--      <div class="item-box">-->
      <!--        <div class="title">-->
      <!--          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon9.png" alt="">-->
      <!--          <span>商家设置</span>-->
      <!--        </div>-->
      <!--        <div class="content">-->
      <!--          <div-->
      <!--            :class="selectNav==8?'item item-select':'item'"-->
      <!--            @click="selectItem(8)"-->
      <!--            >物流公司</div>-->
      <!--          <div-->
      <!--            :class="selectNav==9?'item item-select':'item'"-->
      <!--            @click="selectItem(9)"-->
      <!--          >物流管理</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="item-box">-->
      <!--        <div class="title">-->
      <!--          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon10.png" alt="">-->
      <!--          <span>仓库管理</span>-->
      <!--        </div>-->
      <!--        <div class="content">-->
      <!--          <div-->
      <!--            :class="selectNav==10?'item item-select':'item'"-->
      <!--            @click="selectItem(10)"-->
      <!--            >仓库列表</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="item-box">-->
      <!--        <div class="title">-->
      <!--          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon11.png" alt="">-->
      <!--          <span>配送调拨</span>-->
      <!--        </div>-->
      <!--        <div class="content">-->
      <!--          <div-->
      <!--            :class="selectNav==11?'item item-select':'item'"-->
      <!--            @click="selectItem(11)"-->
      <!--            >配送列表</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon12.png" alt="">
          <span>商家统计</span>
        </div>
        <div class="content">
          <div
            :class="selectNav==8?'item item-select':'item'"
            @click="selectItem(8 )"
          >商家统计
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="title">
          <img class="icon" src="/static/img/personalCenter/PersonalCenter-icon12.png" alt="">
          <span>赊销管理</span>
        </div>
        <div class="content">
          <div :class="selectNav == 9 ? 'item item-select' : 'item'" @click="selectItem(9 )">赊销额度申请</div>
          <div :class="selectNav == 10 ? 'item item-select' : 'item'" @click="selectItem(10 )">赊销额度查询</div>
          <div :class="selectNav == 11 ? 'item item-select' : 'item'" @click="selectItem(11 )">赊销额度提升</div>
<!--          <div :class="selectNav == 12 ? 'item item-select' : 'item'" @click="selectItem(12 )">赊销订单管理</div>-->
<!--          <div :class="selectNav == 12 ? 'item item-select' : 'item'" @click="selectItem(12 )">合同列表管理</div>-->
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {apiShopUser} from '@/api/product';

export default {
  name: 'PersonalCenterNav',
  data () {
    return {
      // buyer:[
      //   'PersonalCenter',//我的订单
      //   'PersonalCenterBuyerSupply',//供应信息
      //   'PersonalCenterPurchaseMessage',//求购信息
      //   'PersonalCenterBrokerInfo',//经纪人信息
      //   'PersonalCompanyInfo',//基本信息
      //   'PersonalAccounts',//账户安全
      //   'PersonalReceiveAddress',//收货地址管理
      // ],
      buyer: [//已弃用，在新加页面的时候去store中加
        ['PersonalCenter'], // 我的订单
        ['PersonalPurchaseOrder'], // 我的求购订单
        ['PersonalPurchaseAfterSales'], // 售后管理
        ['PersonalPurchaseContract'], // 合同管理
        ['PersonalPurchaseInvoice'], // 申请开票
        ['PersonalPurchaseCollect'], // 收藏管理
        ['PersonalMyproperty'], // 我的资产
        ['PersonalCompanyInfo'], // 公司基本信息
        ['PersonalAccounts', 'PersonalPassword', 'Personalforgotpassword', 'PersonalFixpassword', 'Personalsuccess'], // 账号安全
        ['PersonalReceiveAddress'], // 收货地址
        ['PersonalMymessage'], // 我的消息
        ['PersonalLeaveAmessage'], // 我的留言
        ['PersonalRealNameAuthentication'], // 实名认证
        ['PersonalCompanyAuth'], // 公司认证
        ['PersonalCenterBuyerSupply'],
        ['PersonalCenterPurchaseMessage'],
        ['PersonalCenterBrokerInfo'],
        ['PersonalReceiveAddress'],
      ],
      // seller:[
      //   'PersonalSaleOrder',//我的销售订单
      //   'PersonalCommodityManagement',//商品管理
      //   'PersonalStoreInfo'//店铺信息管理
      // ]
      seller: [//已弃用，在新加页面的时候去store中加
        // ['PersonalSaleOrder','PersonalSellerOrderDetail'],
        ['PersonalCommodityManagement', 'PersonalAddProduct', 'PersonalProductDetail'],
        ['PersonalCreditOrderManagementList', 'PersonalCreditOrderManagementDetail'],//赊销订单管理
        ['PersonalStoreInfo'],
        ['PersonalAfterSalesManagement'],//售后管理
        ['PersonalInvoiceManagement'],//发票管理
        ['PersonalContractManagementBackList'],//赊销合同列表管理
        // ['PersonalContractManagement'],//合同管理
        ['PersonalEvaluationList'],//评价列表
        // ['PersonalMerchantManagement'],//商家设置
        // ['PersonalLogisticsSetup'],
        // ['PersonalWarehouseManagement'],//仓库管理
        // ['PersonalLogisticsManagement'],//配送调拨
        ['PersonalBusinessStatistics'],//统计
        ['PersonalCreditSalesApplicationList', 'PersonalCreditSalesApplicationDetail'],//赊销额度申请
        ['PersonalCreditLimitInquiryList', 'PersonalcreditLimitInquiryAllList'],//赊销额度查询
        ['PersonalIncreaseInCreditSalesLimitList', 'PersonalIncreaseInCreditSalesLimitDetail'],//赊销额度提升
      ]
    };
  },
  computed: {
    navTypeIndex () {
      return this.$store.state.headerNavIndex;
    },
    selectNav: {
      get () {
        return this.$store.state.sideNavIndex;
      },
      set (v) {
        this.$store.state.sideNavIndex = v;
      }
    }
  },
  created () {
    this.getShopUser();
  },
  methods: {
    getShopUser () {
      apiShopUser().then(res => {
        console.log('获取用户卖家信息',res.data);
        this.$store.dispatch('setShopUser', res.data);
      });
    },
    selectItem (index, type = false) {
      // console.log(this.navTypeIndex,index);
      if (index == this.selectNav && !type) return;
      this.selectNav = index;
      // 前往各自的页面
      // console.log(this.navTypeIndex === 1,index);
      if (this.navTypeIndex === 1) {
        // 买家
        this.$router.push({name: this.$store.state.buyer[index - 1][0]});
      } else {
        //卖家
        this.$router.push({name: this.$store.state.seller[index - 1][0]});
      }
    }
  }
  , watch: {
    '$route': {
      immediate: true,
      handler (v) {
        if (!v.name) return;
        let res = false;
        this.$store.state.buyer.some((i, index) => {
          i.some((i2) => {
            if (i2 == v.name) {
              res = true;
              this.selectNav = index + 1;
            }
          });
        });
        if (!res) {
          this.$store.state.seller.some((i, index) => {
            i.some((i2) => {
              if (i2 == v.name) {
                res = true;
                this.selectNav = index + 1;
              }
            });
          });
        }
        // console.log(this.selectNav);
      }
    },
    '$store.state.headerNavIndex': {
      immediate: true,
      handler (v) {
        if (this.$store.state.headerNavChangeType != 'click') return;
        if (v === 1 && this.$store.state.buyer[0][0] !== this.$route.name) this.selectItem(1, true);
        if (v === 2 && this.$store.state.seller[0][0] !== this.$route.name) this.selectItem(1, true);
        this.$store.state.headerNavChangeType = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_common.scss";

#nav {
  display: flex;
  flex-direction: column;
  width: 200px;
  height: 100%;
  background-color: #fff;
  padding-top: 8px;

  .item-box {
    background-color: #fff;
    width: 100%;

    .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      cursor: default;

      .icon {
        height: 16px;
        width: 16px;
        margin: 0 16px;
      }

      span {
        font-size: 14px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: 700;
        color: #333333;
        line-height: 22px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      flex: content;
      justify-content: center;
      align-items: center;
      padding: 8px 0;

      .item {
        width: 192px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        padding-left: 45px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        cursor: pointer;
        transition: all 0.2s linear;

        &:hover {
          background-color: #F2F5F2;
        }

        &:nth-child(n + 2) {
          margin-top: 8px;
        }
      }

      .item-select {
        background: #F2F5F2;
        font-weight: 700;
        color: $mainColor;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personalCenterComponents/PersonalCenterNav.vue